import UPNG from 'upng-js';
import type { DelayPair, RgbaFrame } from './types';
import { delayPairToPlaceholderMs } from './delay';
import { patchApngFrameDelays } from './apng-patch';

/**
 * 用 UPNG 编码多帧 APNG（占位 ms delay），再 patch 精确 num/den 与 loop。
 */
export function encodeApng(
  frames: RgbaFrame[],
  delays: DelayPair[],
  loop: number,
): Uint8Array {
  if (frames.length === 0) throw new Error('无帧可编码');
  const w = frames[0]!.width;
  const h = frames[0]!.height;
  for (const f of frames) {
    if (f.width !== w || f.height !== h) {
      throw new Error('所有帧尺寸必须一致');
    }
    if (f.data.length !== w * h * 4) {
      throw new Error('帧数据长度与宽高不匹配（需要 RGBA）');
    }
  }

  const n = frames.length;
  const delayPairs = delays.slice(0, n);
  while (delayPairs.length < n) {
    delayPairs.push(delayPairs[delayPairs.length - 1] ?? [1000, 1000]);
  }

  const dels = delayPairs.map(delayPairToPlaceholderMs);
  // UPNG 需要每帧 ArrayBuffer（非 SharedArrayBuffer 视图共享问题：拷贝保证独立）
  const imgs: ArrayBuffer[] = frames.map((f) => {
    const copy = new Uint8Array(f.data);
    return copy.buffer.slice(copy.byteOffset, copy.byteOffset + copy.byteLength);
  });

  // cnum=0 → 无损
  const encoded = UPNG.encode(imgs, w, h, 0, dels);
  const bytes = new Uint8Array(encoded);
  return patchApngFrameDelays(bytes, delayPairs, loop);
}
